<div [ngStyle]="{ 'width': width, 'height': height }">
  <video #target class="video-js" controls muted preload="none"></video>
</div>
